import {default as attach} from '@lib/App';
import {registerPageAdapter} from '@src/lib/utils/pageAdapter';
import AppComponent from './containers/app';

const initPage = async (data = {}) => {
    await registerPageAdapter({
        openThemeAdapter: {
            useSkin: true,
        },
        openFontAdapter: true,
    });
    // @ts-ignore
    attach(AppComponent, '#app', {
        data,
    });
};

initPage();
